module.exports = __webpack_public_path__ + "img/project-10.03c2e6cd.png";